<template>
  <InputSelect
    :name="name"
    :classes="classes"
    :label="label"
    :help="help"
    :isDisabled="isDisabled"
    :isRequired="isRequired"
    :focusOnMount="focusOnMount"
    v-model="value"
    :options="entityLevelsList"
  ></InputSelect>
</template>

<script>
import { mapGetters } from 'vuex';
import Generator from '@/services/generator/GeneratorService';
import InputMixin from '../InputMixin';

export default {
  name: 'InputEntityLevel',
  mixins: [
    InputMixin,
  ],
  computed: {
    ...mapGetters(['entityLevels']),
    entityLevelsList() {
      return this.entityLevels.map((d) => ({
        v: d,
        n: this.$t(`entityLevel.${d}`),
      })).sort(Generator.nameSort);
    },
  },
};
</script>
